import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import { BrowserRouter as Router } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse';
import { createBrowserHistory } from 'history';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MailIcon from '@material-ui/icons/Mail';

//images
import fb from './images/logo-fb.png';
import yt from './images/logo-youtube.png';
import wp from './images/logo-wordpress.png';
import tw from './images/logo-twitter.png';
import sc from './images/logo-soundcloud.png';
import sLogo from './images/S_logo.png';
import coffee from './images/bmc-button-slimmer.png';

//stylesheet
import './Dashboard.css';

import Routes from '../../App/Routes';

const drawerWidth = 240;
const history = createBrowserHistory();

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      display: 'none',
    },
    backgroundColor: '#000000',
  },
  menuButton: {
    marginRight: theme.spacing(0),
    marginLeft: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: "black",
    color: "white",
    justifyContent: "space-between",
    boxShadow: "10px 5px 10px #0000008c"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  dividerColor: {
    backgroundColor: 'darkgray',
  },
  nested: {
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(0)
  }
}));

function Dashboard(props) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [homeOpen, setHomeOpen] = React.useState(false);
    const [musicOpen, setMusicOpen] = React.useState(false);
    const [teachingOpen, setTeachingOpen] = React.useState(false);
    const [virtualOpen, setVirtualOpen] = React.useState(false);

    const handleClick = (e) => {
      if(e.target.parentNode.parentNode.id === 'home') {
        setHomeOpen(!homeOpen);
        setMusicOpen(false);
        setTeachingOpen(false);
        setVirtualOpen(false);
      } else if(e.target.parentNode.parentNode.id === 'music') {
        setMusicOpen(!musicOpen);
        setHomeOpen(false);
        setTeachingOpen(false);
        setVirtualOpen(false);
      } else if(e.target.parentNode.parentNode.id === 'teaching') {
        setTeachingOpen(!teachingOpen);
        setMusicOpen(false);
        setHomeOpen(false);
        setVirtualOpen(false);
      } else if(e.target.parentNode.parentNode.id === 'virtualInstruments') {
        setVirtualOpen(!virtualOpen);
        setMusicOpen(false);
        setTeachingOpen(false);
        setHomeOpen(false);
      }
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    }

    const closeDrawer = () => {
      setMobileOpen(false);
    }

    const drawer = (
      <Fragment>
        <div>
              <div className="drawer-header">
                <img src={sLogo} alt="S Logo" className="title-bg"/>
                <div className='header-title'>
                  S. Christian Collins
                </div>
                <div className='header-sub-title'>
                  <span>Pianist • Composer</span>
                  <span>Sound Designer</span>
                </div>
              </div>
            <Divider classes={{root: classes.dividerColor}} />
            <List>
              <ListItem
                button
                key="home"
                onClick={handleClick}
                id="home">
                <ListItemText primary="Home" />
              </ListItem>
              <Collapse in={homeOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/"
                  className={classes.nested}>
                  <ListItemText primary="About Chris" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/whatsnew"
                  className={classes.nested}>
                  <ListItemText primary="What's New" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/talents"
                  className={classes.nested}>
                  <ListItemText primary="Talents for Hire" />
                </ListItem>
              </List>
            </Collapse>
              <ListItem button key="music" onClick={handleClick} id="music">
                <ListItemText primary="Music" />
              </ListItem>
              <Collapse in={musicOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
              <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/compositions"
                  className={classes.nested}>
                  <ListItemText primary="Recordings-Original" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/performances"
                  className={classes.nested}>
                  <ListItemText primary="Recordings-Other" />
                </ListItem>
                <ListItem button
                  onClick={closeDrawer}
                  component={Link}
                  to="/sheetmusic-original"
                  className={classes.nested}>
                  <ListItemText primary="Sheet Music-Original" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/sheetmusic-other"
                  className={classes.nested}>
                  <ListItemText primary="Sheet Music-Other" />
                </ListItem>
              </List>
            </Collapse>
            <ListItem button key="teaching" onClick={handleClick} id="teaching">
                <ListItemText primary="Teaching" />
              </ListItem>
              <Collapse in={teachingOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
              <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/musiclessons"
                  className={classes.nested}>
                  <ListItemText primary="Music Lessons" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/forstudents"
                  className={classes.nested}>
                  <ListItemText primary="For Students" />
                </ListItem>
              </List>
            </Collapse>
            <ListItem button key="virtualInstruments" onClick={handleClick} id="virtualInstruments">
                <ListItemText primary="Virtual Instruments" />
              </ListItem>
              <Collapse in={virtualOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/soundfonts"
                  className={classes.nested}>
                  <ListItemText primary="About Virtual Instruments" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/fluidity"
                  className={classes.nested}>
                  <ListItemText primary="Fluidity" />
                </ListItem>
                <ListItem 
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/generaluser"
                  className={classes.nested}>
                  <ListItemText primary="GeneralUser GS" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/guitarandbass"
                  className={classes.nested}>
                  <ListItemText primary="Guitar &amp; Bass" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/orchestral"
                  className={classes.nested}>
                  <ListItemText primary="Orchestral" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/percussion"
                  className={classes.nested}>
                  <ListItemText primary="Percussion" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/virtue"
                  className={classes.nested}>
                  <ListItemText primary="Virtue" />
                </ListItem>
                <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/misc"
                  className={classes.nested}>
                  <ListItemText primary="Miscellaneous" />
                </ListItem>
                {/* <ListItem
                  button
                  onClick={closeDrawer}
                  component={Link}
                  to="/obsolete"
                  className={classes.nested}>
                  <ListItemText primary="Obsolete" />
                </ListItem> */}
              </List>
            </Collapse>
            </List>
        </div>
        <List classes={{ root: classes.smallSocials }} className="socials small-socials">
          <ListItem className="coffee-container">
            <a href="https://buymeacoffee.com/schristiancollins" target="_blank" rel="noopener noreferrer"><img src={coffee} alt="Buy me a coffee" className="coffee"/></a>
          </ListItem>
          <ListItem>
            <div className="tinySocials d-flex row-wrap">
              <a component={Link} href="/contact" className="mr-3"><MailIcon /></a>
              <a href="https://www.youtube.com/user/SChrisCollins" target="_blank" rel="noopener noreferrer">
              <img src={yt} alt="youtube" className="mr-3" /></a>
              <a href="https://schristiancollins.wordpress.com/" target="_blank" rel="noopener noreferrer">
              <img src={wp} alt="WordPress Blog" className="mr-3" /></a>
              <a href="https://www.facebook.com/schristiancollins" target="_blank" rel="noopener noreferrer">
              <img src={fb} alt="facebook" className="mr-3" /></a>
              <a href="https://twitter.com/SChrisCollins" target="_blank" rel="noopener noreferrer">
              <img src={tw} alt="twitter" className="mr-3" /></a>
              <a href="https://soundcloud.com/s-christian-collins" target="_blank" rel="noopener noreferrer">
              <img src={sc} alt="soundcloud" className="mr-3" /></a>
            </div>
          </ListItem>
        </List>
        </Fragment>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

        return (
        <Router history={history}>
        <div className={classes.root}>
          <AppBar position="fixed" className={classes.appBar}>
              <Toolbar disableGutters={true}>
              <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  className={classes.menuButton}
              >
                  <MenuIcon />
              </IconButton>
              <div className='mobile-site-header'>
                <img src={sLogo} alt="S Logo" className="mobile-title-bg"/>
                <div className='mobile-header-title'>
                  S. Christian Collins
                </div>
                <div className='mobile-header-sub-title'>
                  Pianist • Composer • Sound Designer
                </div>
              </div>
              </Toolbar>
          </AppBar>
          <nav className={classes.drawer} aria-label="menu" id="mobileDrawer">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden smUp implementation="css">
              <Drawer
                container={container}
                variant="temporary"
                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                open={mobileOpen}
                onClose={handleDrawerToggle}
                classes={{
                  paper: classes.drawerPaper,
                }}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
              <Drawer
                classes={{
                  paper: classes.drawerPaper,
                }}
                variant="permanent"
                open
              >
                {drawer}
              </Drawer>
            </Hidden>
          </nav>
          <main className={classes.content}>
            <Routes />
          </main>
          </div>
        </Router>
        )
}

export default Dashboard;
